import React from 'react';
import OverlappingReviewSlider from '../components/OverlappingReviewSlider';

const featuredReviews = [
  {
    source: "Reader's Favorite",
    type: 'Editorial Review',
    href: 'https://readersfavorite.com/book-review/the-young-samaritan',
    linkLabel: 'View full review',
    quote:
      "Joshua's journey is full of unexpected allies and challenges, beautifully weaving together hope, faith, and redemption while inviting readers to reflect on divine purpose.",
  },
  {
    source: 'The Midwest Book Review',
    type: 'Editorial Review',
    href: 'https://www.midwestbookreview.com/sbw/may_24.htm#rc',
    linkLabel: 'View full review',
    quote:
      'An engaging and fascinating novel with enormous appeal for readers interested in stories set in the time of Jesus, and a great read from start to finish.',
  },
  {
    source: 'Goodreads',
    type: 'Reader Reviews',
    href: 'https://www.goodreads.com/book/show/204368454-the-young-samaritan?ac=1&from_search=true&qid=2fapwvhqqU&rank=1#CommunityReviews',
    linkLabel: 'View all reviews',
    quote:
      "This coming-of-age adventure follows Joshua through a world as heartbreaking as it is joyful, giving the novel an emotional pull that stays with readers.",
  },
  {
    source: 'Book Viral',
    type: 'Editorial Review',
    href: 'https://bookviralreviews.com/book-reviews/religious-historical-fiction/',
    linkLabel: 'View full review',
    quote:
      'With delicacy befitting the word of God, Sprowles crafts a fascinating and believable account from one Bible verse into an epic journey of hope and inner peace.',
  },
  {
    source: 'Forward Reviews',
    type: 'Trade Review',
    href: 'http://www.forewordreviews.com/reviews/the-young-Samaritan/',
    linkLabel: 'View full review',
    quote:
      'A faithless boy encounters Jesus and opens himself up to new ways of being with others in this heartwarming religious novel.',
  },
  {
    source: 'BlueInk Review',
    type: 'Editorial Review',
    href: 'http://www.blueinkreview.com/book-reviews/the-young-Samaritan/',
    linkLabel: 'View full review',
    quote:
      "By depicting the disciples and Jesus through Joshua's eyes, Sprowles offers a fascinating perspective on the Messiah's earthly life and the hardships of the road.",
  },
  {
    source: 'Red Headed Book Lover',
    type: 'Book Blog Review',
    href: 'https://redheadedbooklover.com/the-young-samaritan-j-schuyler-sprowles/',
    linkLabel: 'View full review',
    quote:
      'A captivating and thought-provoking Biblical tale filled with heart-warming moments and phenomenal literature that keeps pages turning late into the night.',
  },
  {
    source: 'Star 88.3',
    type: 'Interview',
    href: 'https://star883.com/2024/03/28/j/',
    linkLabel: 'Listen to interview',
    quote:
      'A radio conversation about the book, the writing process, and the response to Joshua’s journey.',
  },
  {
    source: 'Bobby Gunther Walsh',
    type: 'Podcast Interview',
    href: 'https://www.iheart.com/podcast/1053-gunther-rewind-22862162/episode/j-schuyler-sprowles-2-22-24-153185007/',
    linkLabel: 'Listen to interview',
    quote:
      'An interview exploring the inspiration behind The Young Samaritan and how the novel grew out of its biblical source.',
  },
];

function TYSReviews() {
  return (
    <>
      <div className='reviews-cover-image-container'>
        <img
          className='reviews-cover-image'
          src={process.env.PUBLIC_URL + '/images/tys-covershot-1.webp'}
          alt=''
        />
      </div>
      <section className='reviews container-medium'>
        <div className='reviews-panel'>
          <div className='reviews-panel__header'>
            <p className='reviews-panel__eyebrow'>Reviews and media</p>
            <h1>What readers and reviewers are saying</h1>
            <p className='reviews-panel__intro'>
              A collection of editorial responses, reader reactions, and
              interviews centered on <em>The Young Samaritan</em>.
            </p>
          </div>
        </div>
        <section className='reviews-slider-section'>
          <div className='reviews-slider-intro'>
            <p className='reviews-slider-kicker'>Featured reactions</p>
            <h2>Drag through the standout praise for The Young Samaritan.</h2>
            <p className='reviews-slider-note'>
              Swipe, drag, or use your arrow keys.
            </p>
          </div>
          <OverlappingReviewSlider reviews={featuredReviews} />
        </section>
      </section>
    </>
  );
}

export default TYSReviews;
